export const isOnlyQaffOrCsr = (profile) => {
  if (!profile || !profile.roles) return false;
  if (profile.roles.filter(r => r.indexOf('qaff') < 0 && (r.indexOf('csr') < 0)).length) {
    return false;
  }
  return true;
};

export const isManagerOrTeamlead = (profile) => {
  if (!profile || !profile.roles) return false;
  if (profile.roles.includes('manager')) return true;
  if (profile.roles.includes('csr_manager')) return true;
  if (profile.roles.includes('csr_teamlead')) return true;

  return false;
}

export const isIrff = (profile) => {
  if (!profile || !profile.roles) return false;

  return profile.roles.includes('irff');
}
